export default __webpack_public_path__ + "static/img-ei-1-9344f1da7620e2067479a6870cc297f6.png";